export const REMISE_LOCALISATION_OPTIONS = [
  { value: "1", label: "Tous" },
  { value: "2", label: "France" },
  { value: "3", label: "DOM-TOM" },
  { value: "4", label: "International" },
  { value: "6", label: "International (France incluse, hors DOM-TOM)" },
] as const;

/** 空值、0 和无法识别的值按「所有地区」处理，与旧保存逻辑一致。 */
export function normalizeRemiseLocalisation(value: unknown): number {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed === 0) return 1;
  return parsed;
}

export function remiseLocalisationLabel(value: unknown): string {
  const code = normalizeRemiseLocalisation(value);
  switch (code) {
    case 1:
      return "Tous";
    case 2:
      return "France";
    case 3:
      return "DOM-TOM";
    case 4:
      return "International";
    case 5:
      return "Liste des pays";
    case 6:
      return "International (France incluse, hors DOM-TOM)";
    default:
      return "Tous";
  }
}
